import companyDataAccess from "src/dataAccess/companies/companyDataAccess";
import customerItemTypeDataaccess from "src/dataAccess/companies/customerItemType.dataaccess";
import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import { ValueLabel } from "src/models/common.models";
import { IListType } from "../store";
import { notification } from "antd";
import { loadingData } from "../common/commonAction";
import questionaryDataccess from "src/dataAccess/questionaries/questionaryDataccess";
import actionPlanDataAccess from "src/dataAccess/actionPlan/actionPlanDataAccess";

export const LoadingData = createAction<boolean>("[Company] Loading data");

export const getCustomerDropdownSuccess = createAction<any>(
  "[Company] Get Supplier Dropdown Data By Type",
);
export const getSupplierDropdownSuccess = createAction<any>(
  "[Company] Get Customer Dropdown Data By Type",
);

export const getCustomerSupplierDropdownByType = createAsyncThunk<
  any,
  "supplier" | "customer"
>(
  "[Company] Get Supplier Customer Dropdown Data By Type",
  async (parameter, thunkAPI) => {
    const result = await companyDataAccess
      .getCompaniesForDropdownByType(parameter)
      .then((res) => {
        let dropdown: ValueLabel[] = res?.data?.map((item) => {
          let data: ValueLabel = {
            value: item.id?.toString(),
            label: item.companyName,
          };
          return data;
        });

        if (parameter === "customer") {
          thunkAPI.dispatch(getCustomerDropdownSuccess(dropdown));
        } else {
          thunkAPI.dispatch(getSupplierDropdownSuccess(dropdown));
        }
        return dropdown;
      });
    return result;
  },
);

export const GetCustomerTypeSuccess = createAction<any>(
  "[Settings] Get Customer-Type settings success",
);
export const GetCustomerType = createAsyncThunk<any, any>(
  "[Settings] Get Customer-Type settings",
  async (_, thunkAPI) => {
    thunkAPI.dispatch(LoadingData(true));
    const result = await customerItemTypeDataaccess
      .getCustomerType()
      .then((res) => {
        thunkAPI.dispatch(GetCustomerTypeSuccess(res));
        thunkAPI.dispatch(LoadingData(false));

        return res;
      });
    return result;
  },
);

export const getSupplierListSuccess = createAction<any>(
  "[Supplier] Get Supplier List Success",
);

export const getSupplierListAsync = createAsyncThunk<any, IListType>(
  "[Supplier] Get Supplier List",
  async (parameter, thunkAPI) => {
    thunkAPI.dispatch(LoadingData(true));
    const result = await companyDataAccess
      .supplierList(parameter, "SuppliersSuppliers")
      .then((res) => {
        thunkAPI.dispatch(getSupplierListSuccess(res));
        thunkAPI.dispatch(LoadingData(false));
        return res;
      });
    return result;
  },
);
export const getSupplierReviewDateListAsync = createAsyncThunk<any, IListType>(
  "[Supplier] Get Supplier Overdue review date List",
  async (parameter, thunkAPI) => {
    thunkAPI.dispatch(LoadingData(true));
    const result = await companyDataAccess
      .getSupplierReviewDateList(parameter)
      .then((res) => {
        thunkAPI.dispatch(getSupplierReviewDateListSuccess(res));
        thunkAPI.dispatch(LoadingData(false));
        return res;
      });
    return result;
  },
);
export const getSupplierReviewDateListSuccess = createAction<any>(
  "[Supplier] Get Supplier Overdue review date List Success",
);
export const getSupplierAttachmentInfoSuccess = createAction<any>(
  "[Supplier] Get Supplier Attachment Info Success",
);

export const saveSupplierAttachmentInfoSuccess = createAction<any>(
  "[Supplier] Save Supplier Attachment Info Success",
);

export const getSupplierAttachmentInfo = createAsyncThunk<any, number>(
  "[Supplier] Get Supplier Attachment Info",
  async (supplierId, thunkAPI) => {
    thunkAPI.dispatch(LoadingData(true));
    const result = await companyDataAccess
      .getSupplierAttachmentInfo(supplierId)
      .then((res) => {
        thunkAPI.dispatch(getSupplierAttachmentInfoSuccess(res?.data));
        thunkAPI.dispatch(LoadingData(false));
        return res;
      });
    return result;
  },
);

export const sendOverdueCertificateEmail = createAsyncThunk(
  "[Supplier] Send Overdue Certificate Email",
  async (
    {
      supplierId,
      dateFieldName,
    }: { supplierId: number; dateFieldName: string },
    thunkAPI,
  ) => {
    thunkAPI.dispatch(LoadingData(true));
    const res = await companyDataAccess.sendOverdueCertificateEmail({
      supplierId: supplierId,
      dateFieldName: dateFieldName,
      dateFieldText: dateFieldName,
    });
    thunkAPI.dispatch(LoadingData(false));
    return res;
  },
);
export const getSupplierQuestionaryListSuccess = createAction<any>(
  "[Supplier] Get Supplier Questionary List Success",
);
export const getSupplierQuestionary = createAsyncThunk<any, number>(
  "[Questionary] Get Supplier Questionary List",
  async (parameter, thunkAPI) => {
    thunkAPI.dispatch(loadingData(true));

    const result = await questionaryDataccess
      .getSupplierQuestionary(parameter)
      .then((res) => {
        thunkAPI.dispatch(getSupplierQuestionaryListSuccess(res));
        thunkAPI.dispatch(loadingData(false));
        return res;
      });
    return result;
  },
);

export const getSupplierMainMenuAuditListSuccess = createAction<any>(
  "[Supplier] Get Supplier Main Menu Audit List Success",
);
export const getSupplierMainMenuAuditListAsync = createAsyncThunk<
  any,
  IListType
>(
  "[Supplier Main Menu] Get Supplier Main Menu Audit List",
  async (parameter, thunkAPI) => {
    thunkAPI.dispatch(loadingData(true));

    const result = await companyDataAccess
      .getSupplierMainMenuAuditList(parameter)
      .then((res) => {
        thunkAPI.dispatch(getSupplierMainMenuAuditListSuccess(res));
        thunkAPI.dispatch(loadingData(false));
        return res;
      });
    return result;
  },
);

export const getSupplierMainMenuAuditDateListSuccess = createAction<any>(
  "[Supplier] Get Supplier Main Menu Audit Date List Success",
);
export const getSupplierMainMenuAuditDateListAsync = createAsyncThunk<
  any,
  IListType
>(
  "[Supplier Main Menu] Get Supplier Main Menu Audit Date List",
  async (parameter, thunkAPI) => {
    thunkAPI.dispatch(loadingData(true));

    const result = await companyDataAccess
      .getSupplierMainMenuAuditDateList(parameter)
      .then((res) => {
        thunkAPI.dispatch(getSupplierMainMenuAuditDateListSuccess(res));
        thunkAPI.dispatch(loadingData(false));
        return res;
      });
    return result;
  },
);

export const getSupplierMainMenuQuestionnaireListSuccess = createAction<any>(
  "[Supplier] Get Supplier Main Menu Questionnaire List Success",
);
export const getSupplierMainMenuQuestionnaireListAsync = createAsyncThunk<
  any,
  IListType
>(
  "[Supplier Main Menu] Get Supplier Main Menu Questionnaire List",
  async (parameter, thunkAPI) => {
    thunkAPI.dispatch(loadingData(true));

    const result = await companyDataAccess
      .getSupplierMainMenuQuestionnaireList(parameter)
      .then((res) => {
        thunkAPI.dispatch(getSupplierMainMenuQuestionnaireListSuccess(res));
        thunkAPI.dispatch(loadingData(false));
        return res;
      });
    return result;
  },
);

export const getSupplierMainMenuRiskAnalysisListSuccess = createAction<any>(
  "[Supplier] Get Supplier Main Menu Risk Analysis List Success",
);
export const getSupplierMainMenuRiskAnalysisListAsync = createAsyncThunk<
  any,
  IListType
>(
  "[Supplier Main Menu] Get Supplier Main Menu Risk Analysis List",
  async (parameter, thunkAPI) => {
    thunkAPI.dispatch(loadingData(true));

    const result = await companyDataAccess
      .getSupplierMainMenuRiskAnalysisList(parameter)
      .then((res) => {
        thunkAPI.dispatch(getSupplierMainMenuRiskAnalysisListSuccess(res));
        thunkAPI.dispatch(loadingData(false));
        return res;
      });
    return result;
  },
);

export const getSupplierMainMenuRequestsListSuccess = createAction<any>(
  "[Supplier] Get Supplier Main Menu Requests List Success",
);
export const getSupplierMainMenuRequestsListAsync = createAsyncThunk<
  any,
  IListType
>(
  "[Supplier Main Menu] Get Supplier Main Menu Requests List",
  async (parameter, thunkAPI) => {
    thunkAPI.dispatch(loadingData(true));

    const result = await companyDataAccess
      .getSupplierMainMenuRequestsList(parameter)
      .then((res) => {
        thunkAPI.dispatch(getSupplierMainMenuRequestsListSuccess(res));
        thunkAPI.dispatch(loadingData(false));
        return res;
      });
    return result;
  },
);

export const getSupplierActionPlanListSuccess = createAction<any>(
  "[Supplier] Get Supplier Action Plan List Success",
);
export const getSupplierActionPlan = createAsyncThunk<any, number>(
  "[ActionPlan] Get Supplier Action Plan",
  async (parameter, thunkAPI) => {
    thunkAPI.dispatch(loadingData(true));

    const result = await actionPlanDataAccess
      .getSupplierActionPlan(parameter)
      .then((res) => {
        thunkAPI.dispatch(getSupplierActionPlanListSuccess(res));
        thunkAPI.dispatch(loadingData(false));
        return res;
      });
    return result;
  },
);

export const getSupplierCompletedQuestionaryListSuccess = createAction<any>(
  "[Supplier] Get Supplier Completed Questionary List Success",
);
export const getSupplierCompletedQuestionary = createAsyncThunk<any, number>(
  "[Questionary] Get Supplier Completed Questionary",
  async (parameter, thunkAPI) => {
    thunkAPI.dispatch(loadingData(true));

    const result = await questionaryDataccess
      .getSupplierCompletedQuestionary(parameter)
      .then((res) => {
        thunkAPI.dispatch(getSupplierCompletedQuestionaryListSuccess(res));
        thunkAPI.dispatch(loadingData(false));
        return res;
      });
    return result;
  },
);

export const getSupplierCertificatesListSuccess = createAction<any>(
  "[Supplier] Get Supplier Certificates List Success",
);

export const getSupplierCertificates = createAsyncThunk<any, number>(
  "[Certificate] Get Supplier Certificates",
  async (supplierId, thunkAPI) => {
    thunkAPI.dispatch(loadingData(true));

    const result = await companyDataAccess
      .getSupplierCertificates(supplierId)
      .then((res) => {
        thunkAPI.dispatch(getSupplierCertificatesListSuccess(res));
        thunkAPI.dispatch(loadingData(false));
        return res;
      });
    return result;
  },
);

export const getSupplierCertificateDetailsSuccess = createAction<any>(
  "[Supplier] Get Supplier Certificate Details Success",
);

export const getSupplierCertificateDetails = createAsyncThunk<
  any,
  { id: number; supplierId: number }
>(
  "[Certificate] Get Supplier Certificate Details",
  async ({ id, supplierId }, thunkAPI) => {
    thunkAPI.dispatch(loadingData(true));

    const result = await companyDataAccess
      .getSupplierCertificateDetails(id)
      .then((res) => {
        thunkAPI.dispatch(getSupplierCertificateDetailsSuccess(res));
        thunkAPI.dispatch(loadingData(false));
        return res;
      });
    return result;
  },
);

export const SaveAndEditContinue = createAction<any>(
  "[Supplier] Save And Edit Continue",
);

export const getSupplierNonConformancesListSuccess = createAction<any>(
  "[Supplier] Get Supplier Non Conformance List Success",
);

export const getSupplierNonConformances = createAsyncThunk<any, number>(
  "[Certificate] Get Supplier Non Conformance List",
  async (supplierId, thunkAPI) => {
    thunkAPI.dispatch(loadingData(true));

    const result = await companyDataAccess
      .getSupplierNonConformances(supplierId)
      .then((res) => {
        thunkAPI.dispatch(getSupplierNonConformancesListSuccess(res));
        thunkAPI.dispatch(loadingData(false));
        return res;
      });
    return result;
  },
);
